import { render, staticRenderFns } from "./question-group-card.vue?vue&type=template&id=64e392b4&scoped=true"
import script from "./question-group-card.vue?vue&type=script&lang=ts"
export * from "./question-group-card.vue?vue&type=script&lang=ts"
import style0 from "./question-group-card.vue?vue&type=style&index=0&id=64e392b4&prod&lang=scss"
import style1 from "./question-group-card.vue?vue&type=style&index=1&id=64e392b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e392b4",
  null
  
)

export default component.exports